<template>
  <section id="chatChannels" class="chat-wrapper">
    <!-- Channel Listing Header -->
    <div class="chat-groups-header">
      <div class="row">
        <div class="col-1">
          <div class="chat-close" @click="recycleChannels"><i class="fas fa-sync-alt"></i></div>
        </div>
        <div class="col chat-groups-title">
          <span>Chat Sessions</span>
        </div>
        <!-- <div class="col-md-1">
        <div class="chat-close" @click="showManage"><i class="fas fa-cog"></i></div>
      </div> -->
        <div class="col-1">
          <div class="chat-close" @click="closeChannels"><i class="fas fa-times"></i></div>
        </div>
      </div>
    </div>
    <!-- Channel Listing -->
    <div class="row chat-groups-group-row">
      <div class="col chat-groups-page-content chat-content">
        <!-- My Accordion Tabs (My Chat Sessions, Active Requests) -->
        <div id="chatGroups">
          <div v-for="(firm, idx1) in myTabs" :key="idx1">
            <div :id="`heading_${idx1}-mychats`">
              <button :id="`accordion-${idx1}-mychats`" class="accordion btn btn-link btn-block" @click="toggleAccordion(`${idx1}-mychats`)">
                <div>
                  <span class="ms-5">{{ firm.name }}</span>
                  <!-- if My Chats (adhoc), allow for creating new Channels -->
                  <div v-if="firm.firm === 0">
                    <button class="btn btn-link chat-link-add" @click="addNewChat">add</button>
                  </div>
                  <span class="chat-badge-unread chat-groups-unread" v-show="firm.unreadCount > 0">{{ firm.unreadCount }}</span>
                </div>
              </button>
            </div>
            <div :id="`panel-${idx1}-mychats`" class="accordion-panel">
              <!-- list of Channels (underneath accordion header) -->
              <div
                v-for="(item, idx2) in joinedChannels(firm)"
                :key="idx2"
                class="chat-groups-group"
                :class="{ 'chat-groups-adhoc': item.firm === 0 }"
                @click="showMessages(item)"
              >
                <!-- My Chats -->
                <div v-if="firm.firm === 0" class="chat-groups-content">
                  <div class="chat-groups-name">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <!-- Locations (for request channels) -->
                <div v-else class="chat-groups-content">
                  <div class="chat-groups-name">
                    <span>#{{ item.name }} - RO {{ item.metadata.ronumber }}</span>
                  </div>
                  <div class="chat-groups-info">
                    <div class="chat-groups-footer">
                      <span class="chat-groups-firm">{{ !isShop ? item.metadata.firmName : '' }}</span>
                      <span class="chat-groups-created">{{ vehicleInfo(item) }}</span>
                    </div>
                  </div>
                </div>
                <i v-if="item.isMessages" class="fas fa-comments chat-groups-comments"></i>
                <span class="chat-badge-unread chat-groups-unread" v-show="item.unreadCount > 0">{{ item.unreadCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="joinedTabs.length > 0" class="chat-groups-accordion-separator">
          <span>Joined Sessions</span>
        </div>
        <!-- Joined Accordion Tabs (Joined Chat Sessions) -->
        <div :key="isRender" id="chatGroups">
          <!-- Accordion (channel groups) - Centers/Dispatch will see accordions -->
          <div v-for="(firm, idx3) in joinedTabs" :key="idx3">
            <div :id="`heading_${idx3}-joined`">
              <button :id="`accordion-${idx3}-joined`" class="accordion btn btn-link btn-block" @click="toggleAccordion(`${idx3}-joined`)">
                <div>
                  <span class="ms-5">{{ firm.name }}</span>

                  <span class="chat-badge-unread chat-groups-unread" v-show="firm.unreadCount > 0">{{ firm.unreadCount }}</span>
                </div>
              </button>
            </div>
            <div :id="`panel-${idx3}-joined`" class="accordion-panel">
              <!-- list of Channels (underneath accordion header) -->
              <div
                v-for="(item, idx4) in firmChannels(firm)"
                :key="idx4"
                class="chat-groups-group"
                :class="{ 'chat-groups-adhoc': item.firm === 0 }"
                @click="showMessages(item)"
              >
                <!-- My Chats -->
                <div v-if="firm.firm === 0" class="chat-groups-content">
                  <div class="chat-groups-name">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
                <!-- Locations (for request channels) -->
                <div v-else class="chat-groups-content">
                  <div class="chat-groups-name">
                    <span>#{{ item.name }} - RO {{ item.metadata.ronumber }}</span>
                  </div>
                  <div class="chat-groups-info">
                    <div class="chat-groups-footer">
                      <span class="chat-groups-firm">{{ !isShop ? item.metadata.firmName : '' }}</span>
                      <span class="chat-groups-created">{{ vehicleInfo(item) }}</span>
                    </div>
                  </div>
                </div>
                <i v-if="item.isMessages" class="fas fa-comments chat-groups-comments"></i>
                <span class="chat-badge-unread chat-groups-unread" v-show="item.unreadCount > 0">{{ item.unreadCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else>
          Shop Users will only see Request Channels (note: no My Chats)
          <div v-for="(item, idx5) in channels" :key="idx5" class="chat-groups-group" @click="showMessages(item)">
            <div class="chat-groups-content">
              <div class="chat-groups-name">
                <span>RO# {{ item.metadata.ronumber }} - #{{ item.name }}</span>
                <span class="chat-badge-unread chat-groups-unread" v-show="item.unreadCount > 0">{{ item.unreadCount }}</span>
              </div>
              <div class="chat-groups-info">
                <div class="chat-groups-footer">
                  <span class="chat-groups-created">{{ vehicleInfo(item) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import globals from '@/plugins/globals'
export default {
  name: 'chat-groups',
  data() {
    return {
      actionNew: null,
      isRender: 0
    }
  },
  mounted() {
    globals.dragElement(document.getElementById('chatChannels'))
  },
  watch: {
    changed(data) {
      console.log('Chat Channels - changed triggered', data)
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channels', 'mychannels', 'requests', 'firmCounts', 'changed']),
    isShop() {
      let _is = false
      if (this.profile) {
        if ([15, 16, 17].includes(this.profile.roles[0])) {
          _is = true
        }
      }
      return _is
    },
    myTabs() {
      let _tabs = []
      let _cnt = 0
      if (this.firmCounts) {
        this.firmCounts.forEach(tab => {
          if (tab.firm === -1 || tab.firm === 0) {
            tab.index = _cnt
            _tabs.push(tab)
            _cnt++
          }
        })
      }
      console.log('My Tabs', _tabs)
      return _tabs
    },
    joinedTabs() {
      let _tabs = []
      let _cnt = 1000
      if (this.firmCounts) {
        this.firmCounts.forEach(tab => {
          if (tab.firm !== -1 && tab.firm !== 0) {
            tab.index = _cnt
            _tabs.push(tab)
            _cnt++
          }
        })
      }
      console.log('Joined Tabs', _tabs)
      return _tabs
    }
  },
  methods: {
    toggleAccordion(idx) {
      let acc = document.getElementById(`accordion-${idx}`)
      acc.classList.toggle('accordion-active')
      let accPanel = document.getElementById(`panel-${idx}`)
      if (accPanel.style.maxHeight) {
        accPanel.style.maxHeight = null
      } else {
        accPanel.style.maxHeight = accPanel.scrollHeight + 'px'
      }
    },
    closeModal() {
      this.actionNew = null
    },
    setGroupClass(firm) {
      return firm.firm === 0 ? 'chat-my-chats' : null
    },
    refreshChannels() {
      let $this = this
      setTimeout(() => {
        $this.isRender += 1
        $this.$forceUpdate()
      }, 200)
    },
    recycleChannels() {
      this.$emit('recycle')
    },
    firmChannels(firm) {
      let channels = []
      if (firm.firm !== -1 && firm.firm !== 0) {
        if (this.channels) {
          channels = this.channels.filter(x => parseInt(x.metadata.firm) === parseInt(firm.firm))
        }
      }
      return channels
    },
    joinedChannels(firm) {
      let channels = []
      if (firm.firm === -1) {
        if (this.requests) {
          if (parseInt(firm.firm) === -1) {
            channels = [...channels, ...this.requests]
          }
        }
      } else if (firm.firm === 0) {
        if (this.mychannels) {
          channels = [...channels, ...this.mychannels]
        }
      }
      return channels
    },
    vehicleInfo(item) {
      let data = null
      if (item) {
        data = `${item.metadata.year} ${item.metadata.make} ${item.metadata.model}`
      }
      return data
    },
    showMessages(item) {
      this.$emit('showMessages', item)
    },
    addNewChat() {
      this.$emit('showNew')
    },
    showManage() {
      this.$emit('showManage')
    },
    closeChannels() {
      this.$emit('closeChannels')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-groups.vue